// Default scenarios to use when none are found in the user profile
export const FALLBACK_SCENARIOS = [
  'Casual Everyday',
  'Office Work',
  'Social Outings',
  'Formal Events',
  'Travel',
  'Outdoor Activities',
  'Date Night',
  'Workout',
  'Loungewear'
];
